/* The gallery's petal tick: a quarter-turn per beat with a springy settle,
   pausing briefly on each petal. The rotation lives on the HTML wrapper —
   not the SVG group — because transform-origin on a group inside this
   offset-viewBox SVG resolves inconsistently across engines, while an HTML
   box always rotates about its own center. The mark is four-fold symmetric,
   so every rest pose is identical to the upright logo — which is why the
   rests stay brief: at list-row sizes a resting mark is indistinguishable
   from the static logo, so the tick keeps moving most of each beat to read
   as "working" rather than idle. */
@keyframes phoebe-petal-tick {
    0% {
        transform: rotate(0deg);
        animation-timing-function: cubic-bezier(0.34, 1.4, 0.64, 1);
    }
    19%,
    25% {
        transform: rotate(90deg);
        animation-timing-function: cubic-bezier(0.34, 1.4, 0.64, 1);
    }
    44%,
    50% {
        transform: rotate(180deg);
        animation-timing-function: cubic-bezier(0.34, 1.4, 0.64, 1);
    }
    69%,
    75% {
        transform: rotate(270deg);
        animation-timing-function: cubic-bezier(0.34, 1.4, 0.64, 1);
    }
    94%,
    100% {
        transform: rotate(360deg);
    }
}

.phoebe-petal-tick {
    transform-origin: center;
}

@media (prefers-reduced-motion: no-preference) {
    .phoebe-petal-tick {
        animation: phoebe-petal-tick 2.4s infinite;
    }
}

@media (prefers-reduced-motion: reduce) {
    .phoebe-petal-tick {
        animation: none;
    }
}
